import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

export const Content: React.FC = () => {
	return (
		<Flex sx={{ flexDirection: 'column', gap: 16 }}>
			<Box>
				<Text fontWeight="bold" sx={{ fontSize: 24 }}>
					<Translate value="corgi.app_download.bottom_banner.headline" />
				</Text>
			</Box>
			<Translate value="corgi.app_download.bottom_banner.description" />
			<Text fontWeight="bold">
				<Translate value="corgi.app_download.bottom_banner.ask" />
			</Text>
		</Flex>
	);
};
